import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import { Modal, Table } from "react-bootstrap";
import SearchBoxModal from "../component/SearchBoxModal";
import ModalSearchMulti from "../component/ModalSearchMulti";

export default function FormPhanLoai() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [modalAddType, setModalAddType] = useState(false);
    const [choiceDepartment, setChoiceDepartment] = useState(null);
    const [choiceDepartmentLabel, setChoiceDepartmentLabel] = useState(null);
    const [choiceChecker, setChoiceChecker] = useState(0)
    const [choiceUser, setChoiceUser] = useState(null)
    const [choiceUserFullname, setChoiceUserFullname] = useState(null)
    const [listDepartment, setListDepartment] = useState([])
    const [listProgress, setListProgress] = useState([])
    const [editId, setEditId] = useState(null)
    const [titleProgress, setTitleProgress] = useState(null)

    const [reloadProgress, setReloadProgress] = useState(false)

    const defaultdetail = {
        title: "",
        company_id: 0,
        status: 1
    }
    useEffect(
        function () {
            // console.log(checkLeave);
            if (id > 0) {
                Axios.get(URL_LIST_ALL + "crm_workflow_type/" + id, user.config).then(async (res) => {
                    if (res.data.status === "success") {
                        const dataif = res.data.data
                        if(dataif.department_id){
                            dataif.department_id = JSON.parse(dataif.department_id)
                        }
                        setDetail(dataif);

                    } else console.log(res.data.message);
                }).catch((err) => console.log(err));
            }
        }, [user, id, autoRefresh]
    );
    useEffect(
        function () {
            // console.log(checkLeave);
            if (id > 0) {
                setTitleProgress("")
                setChoiceUser(null)
                setChoiceUserFullname(null)
                setChoiceDepartment(null)
                setChoiceDepartmentLabel(null)
                Axios.get(URL_LIST_ALL + "crm_workflow_step?orderby=position-asc&wf_type=" + id, user.config).then(async (res) => {
                    if (res.data.status === "success") {
                        setListProgress(res.data.data)
                    } else console.log(res.data.message);
                }).catch((err) => console.log(err));
            }
        }, [user, id, autoRefresh, reloadProgress]
    );

    let validForm = {
        title: Yup.string().trim().nullable().required('Vui lòng nhập tên tờ trình').max(150, "Độ dài không quá 150 ký tự"),
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {

            delete values["id"];
            setLoading(true)
            if (values.checkin_status == 1 && values.checkin_status_date) {
                values.checkin_status_date = null
            }
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'crm_workflow_type/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật loại tờ trình thành công',
                            buttons: [{
                                label: 'OK', onClick: () => {
                                    window.location.reload()
                                }
                            }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'crm_workflow_type', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Loại tờ trình đã được thêm mới thành công!',
                            message: 'Người tạo có trách nhiệm đảm bảo sự chính xác của các bước trong quy trình. Vui lòng kiểm tra kỹ trước khi tiến hành sử dụng.',
                            buttons: [{
                                label: 'OK', onClick: () => {
                                    window.location.href = "/edit-workflow_type/" + res.data.id
                                }
                            }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const actionAddItems = () => {
        if (choiceDepartment) {
            setListDepartment(prev => [
                ...prev,
                {
                    department_id: choiceDepartment,
                    department_label: choiceDepartmentLabel,
                    user_id: choiceUser,
                    user_label: choiceUserFullname,
                    kyphu: choiceChecker
                }
            ]);
            setChoiceChecker(0);
            setChoiceDepartment(null);
            setChoiceDepartmentLabel(null);
        }
    }

    const removeItem = (department_id) => {
        setListDepartment(prev =>
            prev.filter(item => item.department_id !== department_id)
        );
    };

    const themTienTrinh = () => {
        if (listDepartment && listDepartment.length > 0) {
            let dataSave = { title: titleProgress, wf_type: id, departments: listDepartment, status: 1 }
            if (editId && editId != 0) {
                Axios.put(URL_LIST_ALL + 'crm_workflow_step/' + editId, dataSave, user.config).then(res => {
                    if (res.data.status === "success") {
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật tiến trình thành công',
                            buttons: [{
                                label: 'OK', onClick: () => {
                                    setReloadProgress(!reloadProgress)
                                }
                            }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                let position = listProgress.length + 1
                dataSave.position = position
                Axios.post(URL_LIST_ALL + 'crm_workflow_step', dataSave, user.config).then(res => {
                    if (res.data.status === "success") {
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới tiến trình thành công',
                            buttons: [{
                                label: 'OK', onClick: () => {
                                    setReloadProgress(!reloadProgress)
                                }
                            }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        }
    }

    const onEditProgress = (item) => {
        setModalAddType(true)
        let list_department = item.departments ? JSON.parse(item.departments) : []
        setEditId(item.id)
        setListDepartment(list_department)
        setTitleProgress(item.title)
    }
    const onDelete = (item) => {
        confirmAlert({
            title: "Thông báo",
            message: "Bạn có chắc muốn xoá ?",
            buttons: [
                {
                    label: "Có",
                    onClick: () => {
                        Axios.delete(URL_LIST_ALL + 'crm_workflow_step/' + item.id, user.config).then(res => {
                            if (res.data.status === "success") {
                                setReloadProgress(!reloadProgress)
                            } else alert(res.data.message);
                        }).catch(err => console.log(err));
                    },
                },
                { label: "Không" },
            ],
        });
    }

    const changePosition = (item, type) => {
        Axios.put(URL_LIST_ALL + 'crm_workflow_step/' + item.id, { type_position: type }, user.config).then(res => {
            if (res.data.status === "success") {
                // window.location.reload()
                setReloadProgress(!reloadProgress)
            } else {
                confirmAlert({
                    title: 'Lỗi',
                    message: res.data.message,
                    buttons: [{ label: 'OK' }]
                });
            }
        }).catch(err => console.log(err));
    }


    return (
        <AkkhorLayout idrole="workflow_type">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/workflow_type">Danh sách loại tờ trình</Link>
                    </li>
                    <li>{id ? 'Sửa loại tờ trình' : 'Thêm mới loại tờ trình'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} loại tờ trình</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 form-group">
                                <label>Tên loại tờ trình <span className="text-danger">*</span></label>
                                <input type="text" placeholder="VD: Tờ trình mua sắm" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>

                            {/* <div className="col-12 col-sm-6 form-group">
                                <label>Áp dụng cho công ty: <small>(Không chọn là sử dụng cho tất cả)</small> </label>
                                <SearchBoxModal apiname={"company"} placeholder="Chọn công ty" colvalue={'id'} colname={'title'} defaultValue={formik.values['company_id']} name='company_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('company_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="company_id"></AlertErrorForm>
                            </div>
                             */}
                            <div className="col-12">
                                <label>Áp dụng cho phòng ban: <small>(Không chọn là sử dụng cho tất cả)</small> </label>
                                <ModalSearchMulti apiname={"parts"} multiple={true} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} 
                                defaultValue={formik.values['department_id']}  name='department_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('department_id', e)
                                    }}></ModalSearchMulti>
                            </div>

                            <div className="col-12 col-sm-6 form-group">
                                <label>Trạng thái: </label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="1">Hoạt động</option>
                                    <option value="0">Ngừng hoạt động</option>
                                </select>
                            </div>
                            {id > 0 &&
                                <div className="col-12">
                                    <h4>Các tiến trình</h4>
                                    <div className="row">
                                        <div className="col-12 d-flex justify-content-end">
                                            <button type="button" className="btn btn-sm btn-info text-white" onClick={() => {
                                                setModalAddType(true)
                                                setEditId(null)
                                                setListDepartment([])
                                            }}>Thêm tiến trình</button>
                                        </div>
                                        {(listProgress && listProgress.length > 0) ?
                                            <div className="col-12">
                                                <Table striped bordered hover className="mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th>stt</th>
                                                            <th>Tên tiến trình</th>
                                                            <th>Các phòng ban liên quan</th>
                                                            <th>#</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {listProgress.map((item, i) => {
                                                            let list_department = item.departments ? JSON.parse(item.departments) : []
                                                            return <tr key={item.id}>
                                                                <td>{i + 1}</td>
                                                                <td>{item.title ? item.title : <>Tiến trình {i + 1}</>}</td>
                                                                <td>
                                                                    {list_department.map((d, j) => {
                                                                        return <div className="row" key={j}>
                                                                            <div className="col-12 col-sm-6">
                                                                                <p>{d.department_label} </p>
                                                                                {d.user_label ? <p>Ký chính: {d.user_label}</p> : null}
                                                                            </div>
                                                                            <div className="col-12 col-sm-6 text-info">Ký phụ: {d.kyphu == 0 ? "Không" : "Có"}</div>
                                                                        </div>
                                                                    })}
                                                                </td>
                                                                <td>
                                                                    <div className="w-100 d-sm-flex">
                                                                        <button className="btn btn-sm btn-info pl-3 pr-3" type="button" onClick={() => onEditProgress(item)}>
                                                                            <span className="fas fa-pencil-alt"></span>
                                                                        </button>
                                                                        <button className="btn btn-sm btn-danger pl-3 pr-3" type="button" onClick={() => onDelete(item)}>
                                                                            <span className="fas fa-trash-alt"></span>
                                                                        </button>
                                                                        <div className="group-button-position">
                                                                            <button className="btn btn-sm btn-outline-secondary" type="button" disabled={i == 0 ? true : false} onClick={() => changePosition(item, "up")}>
                                                                                <span className="fas fa-angle-up"></span>
                                                                            </button>
                                                                            <button className="btn btn-sm btn-outline-secondary" type="button" disabled={i == listProgress.length - 1 ? true : false} onClick={() => changePosition(item, "down")}>
                                                                                <span className="fas fa-angle-down"></span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </div>
                                            :
                                            "Chưa có tiến trình nào"}
                                    </div>
                                </div>
                            }

                            <div className="col-12 form-group mt-5">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu loại tờ trình</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Modal show={modalAddType} className="modal-thread" onHide={() => setModalAddType(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Thêm tiến trình</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-ash">
                    <div className="row">
                        <div className="col-12 col-sm-3">
                            <label>Tên tiến trình </label>
                            <input type="text" placeholder="VD: Tiến trình 1" className="form-control height32" value={titleProgress} onChange={(e) => setTitleProgress(e.target.value)} autoComplete="off" />
                        </div>
                        <div className="col-12 col-sm-3">
                            <label>Chọn phòng ban </label>
                            <SearchBoxModal apiname={"parts"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} defaultValue={choiceDepartment} value={choiceDepartment} name='part_id'
                                onChange={async (e) => {
                                    await setChoiceDepartment(e)
                                }}
                                onLabel={async (e) => {
                                    await setChoiceDepartmentLabel(e)
                                }}
                            ></SearchBoxModal>
                            <AlertErrorForm formik={formik} name="part_id"></AlertErrorForm>
                        </div>
                        <div className="col-12 col-sm-3">
                            <label>Người ký <small>(Áp dụng cá nhân cụ thể)</small></label>
                            <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'title'} defaultValue={choiceUser} value={choiceUser} name='user_id'
                                onChange={async (e) => {
                                    await setChoiceUser(e)
                                }}
                                onLabel={async (e) => {
                                    await setChoiceUserFullname(e)
                                }}

                            ></SearchBoxModal>
                            <AlertErrorForm formik={formik} name="part_id"></AlertErrorForm>
                        </div>
                        <div className="col-12 col-sm-2">
                            <label>Ký nháy</label>
                            <select className="form-select height32" onChange={(e) => setChoiceChecker(e.target.value)} value={choiceChecker}>
                                <option value="0">Không ký nháy</option>
                                <option value="1">Có ký nháy</option>
                            </select>
                        </div>
                        <div className="col-12 col-sm-1 ">
                            <label className="w-100">#</label>
                            <button type="button" className="btn btn-sm btn-info text-white" onClick={() => actionAddItems()}><i className="fas fa-plus"></i></button>
                        </div>
                        <h4 className="w-100 text-center mt-3">Các đơn vị liên quan</h4>
                        {(listDepartment && listDepartment.length > 0) ?
                            <Table striped bordered hover className="d-sm-table">
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Tên Phòng|Ban</th>
                                        <th>Người ký phụ</th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listDepartment.map((item, i) => {
                                        return <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>
                                                <p>{item.department_label}</p>
                                                {item.user_label ? <p>Ký chính: {item.user_label}</p> : null}
                                            </td>
                                            <td>{item.kyphu == 0 ? "Không" : "Có"}</td>
                                            <td><button type="button" className="btn btn-sm btn-danger" onClick={() => removeItem(item.department_id)}>
                                                <i className="fas fa-trash-alt"></i></button>
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                            :
                            <p className="col-12 text-center">Chưa có đơn vị nào được thêm vào tiến trình này</p>
                        }
                        <div className="col-12 d-flex justify-content-center ">
                            <button type="button" className="btn btn-sm btn-info text-white" onClick={() => themTienTrinh()}>Lưu tiến trình</button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </AkkhorLayout>
    );
}
